/* eslint-disable eqeqeq */
import React, { Component, useState, Fragment, useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import {
  TextField,
  Grid,
  Divider,
  Typography,
  Checkbox,
  Collapse,
  CircularProgress,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  IconButton,
  TableHead,
  TableRow,
  Switch,
} from "@material-ui/core";
import clsx from "clsx";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";

import BottomBar from "../../../components/BottomBar/BottomBar";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { HttpRequest } from "../../../utils/httpRequests";
import { IsEmpty } from "../../../utils/helper";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";
import NavBar from "../../../components/NavBar/NavBar";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 500,
    border: "1px solid " + theme.palette.common.white,
  },
  body: {
    fontSize: 14,
    //border: '1px solid '+theme.palette.primary.main,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const styles = (theme) => ({
  root: {
    padding: 20,
    minWidth: 350,
    overFlowX: "auto",
  },
  formControl: {
    minWidth: "100%",
  },
  sectionTitle: {
    fontSize: 19,
    color: "#174a84",
  },
  checkboxDividerLabel: {
    marginTop: 10,
    marginLeft: 5,
    marginRight: 20,
    fontSize: 16,
    fontWeight: 600,
  },
  rootProgress: {
    width: "100%",
    textAlign: "center",
  },
  expand: {
    transform: "rotate(-90deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(0deg)",
  },
  table: {
    width: "100%",
  },
});

function Switches(props) {
  const [open, setOpen] = React.useState(false);
  const [dialogMsg, setDialogMsg] = React.useState("");
  const [switchState, setSwitchState] = React.useState(props.isChecked);

  const handleClickOpen = () => {
    if (switchState) {
      setDialogMsg("Are you sure you want to deactivate?");
    } else {
      setDialogMsg("Are you sure you want to activate?");
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = () => {
    if (switchState) {
      //setSwitchState(event.target.checked);
      props.onChangeAction(props.recordId, 0, setSwitchState);
      handleClose();
    } else {
      //setSwitchState(event.target.checked);
      props.onChangeAction(props.recordId, 1, setSwitchState);
      handleClose();
    }
  };

  return (
    <Fragment>
      <Switch
        checked={switchState}
        //onChange={handleChange}
        onClick={handleClickOpen}
        color="primary"
        name="switch"
        inputProps={{ "aria-label": "primary checkbox" }}
      />
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <Typography
              variant="subtitle1"
              style={{
                color: "#1d5f98",
                fontWeight: 600,
                textTransform: "capitalize",
              }}
            >
              Confirm !
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {dialogMsg}&emsp;
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              No
            </Button>
            <Button
              onClick={handleChange}
              color="primary"
              variant="contained"
              autoFocus
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </Fragment>
  );
}

Switches.propTypes = {
  onChangeAction: PropTypes.func,
  isChecked: PropTypes.bool,
  recordId: PropTypes.any,
};

Switches.defaultProps = {
  onChangeAction: (fn) => fn,
  isChecked: false,
  recordId: "",
};

function FeatureDetail(props) {
  const {
    data,
    featureId,
    featureLabel,
    isChecked,
    i,
    isSelectedProgrammeGroups,
  } = props;

  const [selectedMenuItems, setSelectedMenuItems] = useState(
    isSelectedProgrammeGroups
  );

  // eslint-disable-next-line no-unused-vars
  const [isDisabled, setIsEnabled] = useState(!isChecked);

  // eslint-disable-next-line no-unused-vars
  const [programmeGroupIds, setProgrammeGroupIds] = useState("");

  const handleSetUserId = (value) => {
    setSelectedMenuItems(value);

    let programmeGroupIdArrays = "";
    if (value) {
      let users = value || [];
      let arrLength = value.length || 0;
      for (let i = 0; i < arrLength; i++) {
        if (i == 0) {
          programmeGroupIdArrays = users[i].Id;
        } else {
          programmeGroupIdArrays += "~" + users[i].Id;
        }
      }
      setProgrammeGroupIds(programmeGroupIdArrays);
    }
  };

  const handleCheckBoxChange = (target) => {
    if (target.checked == false) {
      setIsEnabled(true);
    } else if (target.checked == true) {
      setIsEnabled(false);
    }
  };

  useEffect(() => {
    handleSetUserId(selectedMenuItems);
  });

  return (
    <StyledTableRow key={"row" + data.typeLabel + i}>
      <StyledTableCell
        component="th"
        scope="row"
        align="center"
        style={{ width: "30%", borderColor: "#fff" }}
      >
        {featureLabel}
      </StyledTableCell>
      <StyledTableCell
        component="th"
        scope="row"
        align="center"
        style={{ width: "10%", borderColor: "#fff" }}
      >
        <FormControlLabel
          control={
            <Checkbox
              // checked={dt.is}
              onChange={(e) => handleCheckBoxChange(e.target)}
              value={featureId}
              defaultChecked={isChecked}
              id={"checkBox_" + featureId}
              // name={"checkBox_"+data.typeLabel}
              name={"featureId"}
              color="primary"
            />
          }
          label="Assigned"
        />
      </StyledTableCell>
    </StyledTableRow>
  );
}

FeatureDetail.propTypes = {
  i: PropTypes.any,
  isSelectedProgrammeGroups: PropTypes.bool,
  isChecked: PropTypes.bool,
  data: PropTypes.object,
  featureId: PropTypes.any,
  featureLabel: PropTypes.any,
};

FeatureDetail.defaultProps = {
  i: "",
  isSelectedProgrammeGroups: false,
  isChecked: false,
  data: {},
  featureId: "",
  featureLabel: "",
};

function Features(props) {
  const { classes, data, programmeGroupMenuItems, userId } = props;

  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Fragment>
      <Grid item xs={11}>
        <Typography
          color="primary"
          component="div"
          style={{ fontWeight: 600, fontSize: 18, color: "#3f51b5" }}
        >
          <IconButton
            className={clsx(classes.expand, { [classes.expandOpen]: expanded })}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon color="primary" style={{ color: "#3f51b5" }} />
          </IconButton>
          {data.typeLabel}
          <Divider
            style={{
              backgroundColor: "#3f51b5", //"rgb(58, 127, 187)",
              // backgroundColor:"#fff", //"rgb(58, 127, 187)",
              opacity: "0.3",
              marginLeft: 50,
              marginTop: -10,
            }}
          />
        </Typography>
        <Collapse
          style={{ width: "100%", paddingLeft: 50 }}
          in={expanded}
          timeout="auto"
        >
          <div>
            <TableContainer component={Paper}>
              <Table
                className={classes.table}
                size="small"
                aria-label="customized table"
              >
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      align="center"
                      style={{ background: "#3f51b5" }}
                    >
                      Feature
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ background: "#3f51b5" }}
                    >
                      Action
                    </StyledTableCell>
                    {/* <StyledTableCell align="center" style={{backgroundColor:"#1d5f98"}}>Programme Groups</StyledTableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.features.length > 0 ? (
                    data.features.map((dt, i) => (
                      <FeatureDetail
                        key={"featureData" + dt.featureId}
                        classes={classes}
                        data={data}
                        featureId={dt.featureId}
                        featureLabel={dt.featureLabel}
                        isChecked={dt.isChecked}
                        i={i}
                        isOpen={false}
                        userId={userId}
                        programmeGroupMenuItems={programmeGroupMenuItems}
                        isSelectedProgrammeGroups={dt.programmeGroups}
                      />
                    ))
                  ) : this.state.isLoading ? (
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row" colSpan={4}>
                        <center>
                          <CircularProgress />
                        </center>
                      </StyledTableCell>
                    </StyledTableRow>
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row" colSpan={4}>
                        <center>
                          <b>No Data</b>
                        </center>
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Collapse>
      </Grid>
    </Fragment>
  );
}

Features.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object,
  programmeGroupMenuItems: PropTypes.array,
  userId: PropTypes.any,
};

Features.defaultProps = {
  classes: {},
  data: {},
  programmeGroupMenuItems: [],
  userId: "",
};

class F70Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recordId: this.props.match.params.recordId,
      isLoading: false,
      isReload: true,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      userMenuItems: [],
      programmeGroupMenuItems: [],
      userDetail: [],
      user: [],
      userId: [],
      userID: "",
      userIds: "",
      userIdError: "",
      featureMenuItems: [],
      featureId: [],
      featureIds: "",
      featureIdError: "",
      isEditMode: false,
      expanded: false,
    };
  }

  handleOpenSnackbar = (msg, severity) => {
    this.setState({
      isOpenSnackbar: true,
      snackbarMessage: msg,
      snackbarSeverity: severity,
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      isOpenSnackbar: false,
    });
  };

  handleExpandClick = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  onSwitchStatusChange = async (id, isActive, changeSwitch) => {
    const data = new FormData();
    data.append("id", id);
    data.append(" isActive", isActive);
    this.setState({ isLoading: true });

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C70IsActiveStatusUpdate`,
      data,
      "authorize"
    );
    if (res.isSuccess) {
      if (res.statusCode === 1) {
        changeSwitch(true);
        this.handleSnackbar(true, "Status Updated", "success");
        // window.location.reload();
      } else {
        //alert(json.USER_MESSAGE + '\n' + json.SYSTEM_MESSAGE);
        changeSwitch(false);
        this.handleOpenSnackbar(res.message, "error");
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          // isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      isLoading: false,
    });
  };

  loadUsers = async () => {
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/FormRightsAllocationAllUsersView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        this.setState({ userMenuItems: res.data });
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    // this.setState({
    //     isLoading: false,
    // });
  };
  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  loadUsersDetails = async (userId) => {
    const data = new FormData();
    data.append("userId", userId);
    this.setState({ isLoading: true });
    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/FormRightsAllocationUsersDetailView`,
      data,
      "authorize"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        this.setState({ user: res.data[0] || [] });
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          // isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      isLoading: false,
    });
  };

  loadFeatureUsersDetails = async (userId) => {
    const data = new FormData();
    data.append("userId", userId);
    this.setState({ isLoading: true });
    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/FormRightsAllocationUsersFeatureDetailView`,
      data,
      "authorize"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        this.setState({ userDetail: res.data || [] });
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          // isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      isLoading: false,
    });
  };

  loadUsersProgrammeGroups = async () => {
    this.setState({ isLoading: true });
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/FormRightsAllocationAllProgrammeGroupsView2`;
    await fetch(url, {
      method: "POST",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclAdminToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            this.setState({ programmeGroupMenuItems: json.DATA });
          } else {
            this.handleOpenSnackbar(
              <span>
                {json.SYSTEM_MESSAGE}
                <br />
                {json.USER_MESSAGE}
              </span>,
              "error"
            );
          }
        },
        (error) => {
          if (error.status == 401) {
            this.setState({
              isLoginMenu: true,
              isReload: true,
            });
          } else {
            this.handleOpenSnackbar(
              "Failed to fetch ! Please try Again later.",
              "error"
            );
          }
        }
      );
    this.setState({ isLoading: false });
  };

  loadFeatures = async () => {
    this.setState({ isLoading: true });
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/CommonFeaturesViews`;
    await fetch(url, {
      method: "POST",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclAdminToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            this.setState({ featureMenuItems: json.DATA || [] });
          } else {
            this.handleOpenSnackbar(
              <span>
                {json.SYSTEM_MESSAGE}
                <br />
                {json.USER_MESSAGE}
              </span>,
              "error"
            );
          }
        },
        (error) => {
          if (error.status == 401) {
            this.setState({
              isLoginMenu: true,
              isReload: true,
            });
          } else {
            this.handleOpenSnackbar(
              "Failed to fetch ! Please try Again later.",
              "error"
            );
          }
        }
      );
    this.setState({ isLoading: false });
  };

  loadData = async (recordId) => {
    const data = new FormData();
    data.append("id", recordId);
    this.setState({ isLoading: true });
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/FormRightsAllocationViews`;
    await fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclAdminToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            let data = json.DATA || [];
            let dataLength = data.length;
            if (dataLength > 0) {
              if (data[0].userId) {
                this.handleSetUserId([
                  { id: data[0].userId, label: data[0].userLabel },
                ]);
                let features = data[0].features || [];
                this.handleSetFeatureId(features);
                this.setState({ isEditMode: true });
              } else {
                window.location = "#/dashboard/F70Form/0";
              }
            }
          } else {
            this.handleOpenSnackbar(
              <span>
                {json.SYSTEM_MESSAGE}
                <br />
                {json.USER_MESSAGE}
              </span>,
              "error"
            );
          }
        },
        (error) => {
          if (error.status == 401) {
            this.setState({
              isLoginMenu: true,
              isReload: true,
            });
          } else {
            this.handleOpenSnackbar(
              "Failed to Save ! Please try Again later.",
              "error"
            );
          }
        }
      );
    this.setState({ isLoading: false });
  };

  isUsersValid = () => {
    let userId = this.state.userId;
    let isValid = true;
    if (userId.length == 0) {
      this.setState({ userIdError: "Please select at least one user." });
      document.getElementById("userId").focus();
      isValid = false;
    } else {
      this.setState({ userIdError: "" });
    }
    return isValid;
  };

  isFeatureValid = () => {
    let featureId = this.state.featureId;
    let isValid = true;
    if (featureId.length == 0) {
      this.setState({ featureIdError: "Please select at least one feature." });
      document.getElementById("featureId").focus();
      isValid = false;
    } else {
      this.setState({ featureIdError: "" });
    }
    return isValid;
  };

  onHandleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    switch (name) {
      case "":
        break;
      default:
    }
    this.setState({
      [name]: value,
      [errName]: "",
    });
  };

  userSelected = (option) => {
    return this.state.userId.some(
      (selectedOption) => selectedOption.id == option.id
    );
  };

  handleSetUserId = (value) => {
    this.setState({
      userId: value,
      userIdError: "",
      userDetail: [],
      user: [],
    });
    if (value != null && value != "undefined") {
      this.loadUsersDetails(value.id);
      this.loadFeatureUsersDetails(value.id);
      this.setState({ userIds: value.id });
    }
  };

  featureSelected = (option) => {
    return this.state.featureId.some(
      (selectedOption) => selectedOption.id == option.id
    );
  };

  handleSetFeatureId = (value) => {
    this.setState({
      featureId: value,
      featureIdError: "",
    });

    let featureIds = "";
    if (value) {
      let features = value || [];
      let arrLength = value.length || 0;
      for (let i = 0; i < arrLength; i++) {
        if (i == 0) {
          featureIds = features[i].id;
        } else {
          featureIds += "," + features[i].id;
        }
      }
      this.setState({ featureIds: featureIds });
    }
  };

  clickOnFormSubmit = () => {
    this.onFormSubmit();
  };

  viewReport = () => {
    window.location = "#/dashboard/F70Reports";
  };

  componentDidMount() {
    this.loadUsers();
  }
  onFormSubmit = async () => {
    let myForm = document.getElementById("myForm");
    const data = new FormData(myForm);
    this.setState({ isLoading: true });
    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/FormRightsAllocationAllProgrammeGroupsSaveNew`,
      data,
      "authorize"
    );
    if (res.isSuccess) {
      this.handleOpenSnackbar(res.USER_MESSAGE, "success");
      window.location.reload();
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          // isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      isLoading: false,
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.match.params.recordId != nextProps.match.params.recordId) {
      if (nextProps.match.params.recordId != 0) {
        // this.props.setDrawerOpen(false);
        this.loadData(nextProps.match.params.recordId);
      } else {
        window.location.reload();
      }
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <NavBar isAuthorize title="User Rights" />
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <form id="myForm" style={{ marginTop: 50 }} onSubmit={this.isFormValid}>
          <TextField type="hidden" name="id" value={this.state.recordId} />
          <Grid container component="main" className={classes.root}>
            <Grid
              container
              spacing={2}
              xs={6}
              style={{
                marginLeft: 5,
                marginRight: 10,
              }}
            >
              <Grid item xs={12} md={6}>
                <Autocomplete
                  fullWidth
                  id="userId"
                  options={this.state.userMenuItems}
                  value={this.state.userId}
                  onChange={(event, value) => this.handleSetUserId(value)}
                  disabled={this.state.isEditMode}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Users"
                      placeholder="Search and Select"
                      error={!!this.state.userIdError}
                      helperText={this.state.userIdError}
                    />
                  )}
                />
                <TextField
                  type="hidden"
                  name="userId"
                  value={this.state.userIds}
                />
              </Grid>
            </Grid>
            <Grid
              container
              xs={8}
              spacing={2}
              style={{
                marginLeft: 5,
                marginRight: 10,
              }}
            >
              <Typography
                style={{
                  color: "#3f51b5",
                  fontWeight: 600,
                  // borderBottom: "1px solid rgb(58, 127, 187, 0.3)",
                  width: "98%",
                  marginBottom: 25,
                  fontSize: 20,
                }}
                variant="h5"
              >
                User Detail
              </Typography>

              <Grid style={{ background: "#3f51b5" }} item xs={12} md={3}>
                <Typography
                  style={{
                    fontWeight: 400,
                    width: "100%",
                    fontSize: 15,
                    color: "#fff",
                  }}
                  variant="h5"
                >
                  Name
                </Typography>
              </Grid>
              <Grid style={{ background: "#3f51b5" }} item xs={12} md={2}>
                <Typography
                  style={{
                    fontWeight: 400,
                    width: "100%",
                    fontSize: 15,
                    color: "#fff",
                  }}
                  variant="h5"
                >
                  Mobile No
                </Typography>
              </Grid>

              <Grid style={{ background: "#3f51b5" }} item xs={12} md={2}>
                <Typography
                  style={{
                    fontWeight: 400,
                    width: "100%",
                    fontSize: 15,
                    color: "#fff",
                  }}
                  variant="h5"
                >
                  User Type
                </Typography>
              </Grid>

              <Grid style={{ background: "#3f51b5" }} item xs={12} md={2}>
                <Typography
                  style={{
                    fontWeight: 400,
                    width: "100%",
                    fontSize: 15,
                    color: "#fff",
                  }}
                  variant="h5"
                >
                  Status
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              xs={8}
              style={{
                marginLeft: 5,
                marginRight: 10,
                marginTop: 25,
              }}
            >
              <Grid item xs={12} md={3}>
                <Typography
                  style={{
                    fontWeight: 400,
                    width: "100%",
                    fontSize: 15,
                  }}
                  variant="h5"
                >
                  {this.state.user.userLabel}
                </Typography>
              </Grid>
              <Grid item xs={12} md={2}>
                <Typography
                  style={{
                    fontWeight: 400,
                    width: "100%",
                    fontSize: 15,
                  }}
                  variant="h5"
                >
                  {this.state.user.userMobile}
                </Typography>
              </Grid>

              <Grid item xs={12} md={2}>
                <Typography
                  style={{
                    fontWeight: 400,
                    width: "100%",
                    fontSize: 15,
                  }}
                  variant="h5"
                >
                  {this.state.user.userType}
                </Typography>
              </Grid>

              <Grid item xs={12} md={2}>
                {!IsEmpty(this.state.user) ? (
                  <Switches
                    key={
                      "abc_1" +
                      this.state.user.userId +
                      this.state.user.userIsActive
                    }
                    isChecked={this.state.user.userIsActive == 1}
                    recordId={this.state.user.userId}
                    onChangeAction={this.onSwitchStatusChange}
                  />
                ) : (
                  ""
                )}
              </Grid>
            </Grid>

            <Grid xs={6} style={{ marginBottom: 50 }}>
              {this.state.userDetail.map((data, index) => (
                <Features
                  key={"featureData" + index}
                  classes={classes}
                  data={data}
                  isOpen={false}
                  userId={this.state.userId}
                  userMenuItems={this.state.userMenuItems}
                  programmeGroupMenuItems={this.state.programmeGroupMenuItems}
                />
              ))}
            </Grid>
            <br />
            <br />
            <br />
            <br />
          </Grid>
        </form>

        <BottomBar
          rightButtonDisable={this.state.isLoading}
          // leftButtonAction ={() => this.viewReport()}
          // leftButtonText ="View"
          leftButtonHide
          rightButtonText="Submit"
          rightButtonAction={() => this.clickOnFormSubmit()}
        />
        <CustomizedSnackbar
          isOpen={this.state.isOpenSnackbar}
          message={this.state.snackbarMessage}
          severity={this.state.snackbarSeverity}
          handleCloseSnackbar={() => this.handleCloseSnackbar()}
        />
      </Fragment>
    );
  }
}

F70Form.propTypes = {
  classes: PropTypes.object,
  match: PropTypes.object,
};

F70Form.defaultProps = {
  classes: {},
  match: {
    params: {},
  },
};

export default withStyles(styles)(F70Form);
